var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable @typescript-eslint/no-use-before-define */
import { degToRad } from '../../utils/math';
export function wordcloudLyaout(words, options) {
    // console.time('layout')
    var shape = options.shape, ellipticity = options.ellipticity, width = options.width, height = options.height, gridSize = options.gridSize, rotateRatio = options.rotateRatio;
    var rotationRange = Math.abs(options.maxRotation - options.minRotation);
    var rotationSteps = Math.abs(Math.floor(options.rotationSteps));
    var minRotation = Math.min(options.maxRotation, options.minRotation);
    var g = Math.max(gridSize, 4);
    var ngx = Math.ceil(width / g);
    var ngy = Math.ceil(height / g);
    var cx = ngx / 2;
    var cy = ngy / 2;
    var maxRadius = Math.floor(Math.sqrt(ngx * ngx + ngy * ngy));
    var grid = [];
    var points = getGridPoints();
    words.forEach(function (word) {
        var boxWidth = word.width;
        var boxHeight = word.height;
        var rotateRad = getRotateRad();
        var occupied = [];
        for (var i = 0; i < points.length; i++) {
            occupied.length = 0;
            var _a = points[i], px = _a[0], py = _a[1];
            // clientBoundingRect
            var cgw = (boxWidth * Math.abs(Math.cos(rotateRad)) + boxHeight * Math.abs(Math.sin(rotateRad))) / g;
            var cgh = (boxWidth * Math.abs(Math.sin(rotateRad)) + boxHeight * Math.abs(Math.cos(rotateRad))) / g;
            var minX = Math.floor(px - cgw / 2);
            var maxX = Math.floor(px + cgw / 2);
            var minY = Math.floor(py - cgh / 2);
            var maxY = Math.floor(py + cgh / 2);
            var failed = false;
            for (var x = minX; x <= maxX; x++) {
                if (failed) {
                    break;
                }
                // tood 考虑超出canvas边界
                for (var y = minY; y <= maxY; y++) {
                    if ((grid[x] && grid[x][y]) || !(y >= 0 && y <= ngy && x >= 0 && x <= ngx)) {
                        failed = true;
                        break;
                    }
                    occupied.push([x, y]);
                }
            }
            if (!failed) {
                points.splice(i, 1);
                word.rotation = rotateRad;
                word.cx = options.x + px * g;
                word.cy = options.y + py * g;
                word.grids = __spreadArrays(occupied);
                word.visible = true;
                occupied.forEach(function (item) {
                    if (!grid[item[0]]) {
                        grid[item[0]] = [];
                    }
                    grid[item[0]][item[1]] = true;
                });
                break;
            }
        }
    });
    points.length = 0;
    grid.length = 0;
    // console.timeEnd('layout')
    function getGridPoints() {
        var ret = [[cx, cy]];
        var LOOK_FOR_NUMBER = 8;
        for (var i = 1; i < maxRadius + 1; i++) {
            for (var j = 0; j < LOOK_FOR_NUMBER * i; j++) {
                var radius = i;
                var theta = (j / (LOOK_FOR_NUMBER * i)) * Math.PI * 2;
                var rx = shape === 'circle' ? 1 : getShapeRadius(shape, theta);
                var px = cx + radius * rx * Math.cos(theta);
                var py = cy + radius * rx * Math.sin(theta) * ellipticity;
                if (px >= 0 && py >= 0 && px <= ngx && py <= ngy) {
                    ret.push([px, py]);
                }
            }
        }
        return ret;
    }
    function getRotateRad() {
        if (rotateRatio === 0) {
            return 0;
        }
        if (Math.random() > rotateRatio) {
            return 0;
        }
        if (rotationRange === 0) {
            return degToRad(minRotation);
        }
        if (rotationSteps > 0) {
            // Min rotation + zero or more steps * span of one step
            return degToRad(minRotation +
                (Math.floor(Math.random() * rotationSteps) * rotationRange) / (rotationSteps - 1));
        }
        return degToRad(minRotation + Math.random() * rotationRange);
    }
}
function getShapeRadius(shape, theta) {
    if (shape === 'square') {
        return shapeSquare(theta);
    }
}
function shapeSquare(theta) {
    return Math.min(1 / Math.abs(Math.cos(theta)), 1 / Math.abs(Math.sin(theta)));
}
